import { createFileRoute, Outlet } from '@tanstack/react-router';
import {
  commonSearchSchema,
  searchTextParam,
} from '@/routes/-shared/commonSearchSchema';
import { RoleGuard } from '@/components/molecules/role-guard';
import { usePermissions } from '@/hooks/use-permissions';
import z from '@/lib/zod';

export const productsSearchSchema = commonSearchSchema.extend({
  search: searchTextParam,
});

export type ProductsSearchSchema = z.infer<typeof productsSearchSchema>;

export const Route = createFileRoute('/protected/_layout/products/_layout')({
  validateSearch: productsSearchSchema,
  component: ProductsLayout,
});

function ProductsLayout() {
  // Listing consolidato sotto `/warehouse?subTab=products`: questo layout
  // serve solo da contenitore per le route detail (`/products/$id`,
  // `/products/new`) che aprono la SheetView del form articolo. La
  // pagina nuda `/products` redireziona al tab Prodotti del Magazzino
  // via `_layout.index.tsx`.
  const { canAccessProducts, isLoading } = usePermissions();

  return (
    <RoleGuard hasAccess={canAccessProducts} isLoading={isLoading}>
      <Outlet />
    </RoleGuard>
  );
}
